import React, { useEffect, useRef, useState } from "react";
import { eventBus } from "../../services/eventHandler";
import moment from "moment";
import { useBlade } from "../../services/BladeProvider";
import UserTypChooice, { GetUserTypeNammes } from "../Tools/UserTypChooice";
import Clock from "../Tools/Clock";
import { REACT_APP_BUILD_TIME } from './../../env.build.js'

interface Props {
  onOpenModal: () => void;
}

const ResultFooter = ({onOpenModal}:Props) => {
  const {getUserType} = useBlade()
  const [isOffline,setIsOffline] = useState(false);
  const isOfflineref = useRef(isOffline);
  let tim = moment(REACT_APP_BUILD_TIME).format("YYMMDDHHmm");
  useEffect(() => {
    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      // Cleanup listeners on unmount
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    }

  },[]);
  useEffect(() => {
    isOfflineref.current = isOffline;
  },[isOffline]);

  const handleOffline = () => {
    if (!isOfflineref.current)
    {
      setIsOffline(true);
    }
  }
  const handleOnline = () => {
    if (isOfflineref.current)
      {
        setIsOffline(false);
      }
  }
  
  return (
    <>
    {isOffline &&  <div style={{position: "absolute", width: "100%", height: "100%", background: "#ff0000cf", textAlign: "center", fontSize: "30px"}}>
      <span>OFFLINE, trying to reconnect</span>
    </div>}
      <div className="result-footer-info">
        <span>© EliteTiming of Sweden AB</span>
        <span>® Alfred Andersson ({tim})</span>
      </div>
      <div className="result-footer-center">        
        <span className="result-footer-center-text" onClick={() => onOpenModal()}>Usertype: {GetUserTypeNammes(getUserType())}</span>
      </div>
      <div className="result-footer-clock">
        <span className="result-footer-clock-time">
          <Clock />
        </span>
        <br></br>
        <span className="result-footer-clock-text">EliteTiming</span>
      </div>
    </>
  );
};
export default ResultFooter;
